var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBackgroundWavesUpsideMobile = function SvgBackgroundWavesUpsideMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 320 30",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M320 0L0 0L0 30L2.7179e-06 24.9107C9.41095 27.5384 19.6855 26.0988 28.1502 20.592C39.6109 13.1361 54.3894 13.1361 65.8501 20.592C77.3109 28.0479 92.0894 28.0479 103.55 20.592C115.011 13.1362 129.789 13.1361 141.25 20.592C152.711 28.0479 167.489 28.0479 178.95 20.592C190.411 13.1361 205.189 13.1361 216.65 20.592C228.111 28.0479 242.889 28.0479 254.35 20.592C265.811 13.1361 280.589 13.1362 292.05 20.592C300.455 26.0598 310.644 27.5178 320 24.966V0Z"
  })));
};
export default SvgBackgroundWavesUpsideMobile;